<template>
  <div class="login_page">
    <!-- <h2 class="text-center rounded">LinenTech <span>C Panel</span></h2> -->
    <h2 class="text-center rounded">Foxtek Systems <span>C Panel</span></h2>
    <form class="form-signin">
      <h4 class="h4 mb-4 text-center">
        <font-awesome-icon class="mr-1" icon="lock" />
        Login
      </h4>
      <ul v-if="flag" style="list-style: none;" class="alert alert-danger">
        <a href="#" class="close" data-dismiss="alert" @click="quit">×</a>
        <li v-if="errors.length">{{errors[0]}}
        <li v-else >These credentials do not match our records.</li>
      </ul>
      <label for="inputEmail" class="sr-only">Username</label>
      <input type="username" v-model="username" class="form-control mb-3" placeholder="username" required autofocus>

      <div class="input-group mb-3">
          <input v-bind:type="[showPassword ? 'text' : 'password']" v-model="password" class="form-control" placeholder="Password" required>
        <div class="input-group-append">
          <span class="input-group-text" @click="showPassword = !showPassword">
            <i class="fa" style="cursor: pointer;  color: #48a6a6;" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div class="checkbox mb-2">
        <label style="font-size:0.9em">
          <input type="checkbox" style="vertical-align: text-top" v-model="remember"> Remember me
        </label>
      </div>

      <button class="btn btn-primary btn-block" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" type="submit" @click.prevent="login">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; margin-top: 3px;" />
        <span v-if="!isMiniLoading">Sign In</span>
      </button>

      <hr />

      <!-- <div style="font-size:0.9em" class="text-center mt-1 text-secondary">
        Forgot your password?
        <router-link  class="" to="/register">
          Click here
        </router-link>
      </div> -->
    </form>
  </div>

</template>

<script>

 import helpers from "@/helpers.js";

  export default {
    
    data: function () {

      return {
        errors: [],
        isMiniLoading : false,
        showPassword:false,
        // email: '',
        username: '',
        password: '',
        remember: false,
        flag: false,
        products: [],
      }
    },
    computed: function () {
      this.flag = false;
    },
    methods: {
      login() {
        this.isMiniLoading = true;
        let redirect = this.$auth.redirect();
        this.$auth.login({
          url: '/auth/login',
          data: {
            // email: this.email,
            username: this.username,
            password: this.password
          },
          rememberMe: this.remember,
          success: (response) => {
            this.products = response.data.products;
            this.$store.dispatch("persist/setAvailableProducts", this.products);
            this.$store.dispatch("persist/setSelectedProduct", response.data.user_product[0]);
            localStorage.setItem('product', response.data.user_product[0]);
            localStorage.setItem('role', response.data.user.role_id);
            localStorage.setItem('admin_id', response.data.user.id);
            localStorage.setItem('f_name', response.data.user.first_name);
            localStorage.setItem('l_name', response.data.user.last_name);
            localStorage.setItem('user_product', response.data.user_product);
            localStorage.setItem('user_permissions', JSON.stringify(response.data.user_permissions));
            this.$auth.user(response.data.user);
            this.$auth.token('access_token', response.data.token);
            this.isMiniLoading = false;
            this.$store.dispatch("teams/getAll");
            this.$store.dispatch("users/orgMasterUsers");
            this.$store.dispatch('users/getUsers');
          },
          error: (error) => {
            this.isMiniLoading = false;
            //alert('Invalid Credentials! Please try again.');
             if(this.username == '' && this.password == ''){
                this.flag= true;
                this.errors = [];
                this.errors.push('Username & Email is required.');
              }else if(this.username == ''){
                this.errors = [];
                this.errors.push('Username is required.');
              }else if(this.password == ''){
                this.errors = [];
                this.errors.push('Password is required.');
              }else{
                this.errors = [];
                this.flag = true;
              }
          },
          fetchUser: false
        });
        
      },
      quit() {
        this.flag = false;
      }
    }


  }

</script>